import { Badge, Col, Container, Row } from "react-bootstrap";
import { STORAGE_KEY } from "../../constants/storageKeys"
import { getLocalStorage, removeLocalStorage } from "../../utils/localStorage"
import Character from "./Character";
import { useEffect, useRef, useState } from "react";
import { getPlayersbyToken, startGame, stopGame } from "../../services/authService";
import { BATTLE_RESULT, HANDLE_EVENT_CHARACTER, PLAYER_CONFIG, RESOURCES_ID, SOCKET_EVENT, TIMEOUT_FARMING_SEADFOOD, TIMEOUT_ONLINE } from "../../constants/Common";
import { SCREEN_ROUTER } from "../../constants/screenRouter";
import { HOST_AUTO_SERVER, HOST_SOCKET_SERVER, PATH_SOCKET_SERVER } from "../../constants/api";
import { io } from "socket.io-client";
import usePlayerConfig from "../../hooks/usePlayerConfig";
import usePlayerInfo from "../../hooks/usePlayerInfo";
import useMapInfo from "../../hooks/useMapInfo";
import useOnlineInfo from "../../hooks/useOnlineInfo";
import useIsUpdateCookie from "../../hooks/useIsUpdateCookie";
import useNlcInfo from "../../hooks/useNlcInfo";
import useTotalNlc from "../../hooks/useTotalNlc";
import { useNavigate } from "react-router-dom";
import nextScreen from "../../utils/navigateScreen";
import usePlayerResourceTotal from "../../hooks/usePlayerResourceTotal";
import usePlayerResourceQuantity from "../../hooks/usePlayerResourceQuantity";
import useQcAutoOnline from "../../hooks/useQcAutoOnline";
import useQcAtkCityIds from "../../hooks/useQcAtkCityIds";
import useQcAtkingCityIds from "../../hooks/useQcAtkingCityIds";
import useQcAtkingPlayers from "../../hooks/useQcAtkingPlayers";
import useQcDefCityIds from "../../hooks/useQcDefCityIds";
import useQcCityInfos from "../../hooks/useQcCityInfos";
import { toast } from "react-toastify";
import { CODE_EXPIRED } from "../../constants/errMessage";
import useUuidFree from "../../hooks/useUuidFree";
import usePlayerEquipment from "../../hooks/usePlayerEquipment";
import useRemoveEquipment from "../../hooks/useRemoveEquipment";
import usePlayerTrucLoc from "../../hooks/usePlayerTrucLoc";
import { stringToShort } from "../../utils/common";

const DashBoard = () => {
    const localUserInfo = getLocalStorage(STORAGE_KEY.USER_INFO);
    const localPlayerInfo = getLocalStorage(STORAGE_KEY.PLAYER_INFO);
    const localServerInfo = getLocalStorage(STORAGE_KEY.SERVER_INFO);
    const localCookieInfo = getLocalStorage(STORAGE_KEY.COOKIE_INFO);
    const localTokenInfo = getLocalStorage(STORAGE_KEY.LOGIN_TOKEN);
    const idTimeout = {};
    const idTimeoutFarmingSeaFood = {}
    const [playersInfo, setPlayersInfo] = useState([]);
    const allPlayerId = [];
    const [farmingSeaFood, setFarmingSeaFood] = useState({});
    const socketRef = useRef(null);

    const navigate = useNavigate();

    const { updateSingleResourceTotal, updatePlayerResourceTotal } = usePlayerResourceTotal()
    const { updateSingleResourceQuantity, updatePlayerResourceQuantity } = usePlayerResourceQuantity()
    const { playerConfigs, updatePlayerConfig } = usePlayerConfig()
    const { playerInfos, updatePlayer } = usePlayerInfo()
    const { maps, setMap } = useMapInfo()
    const { onlines, setOnline } = useOnlineInfo();
    const { isUpdateCookie } = useIsUpdateCookie();
    const { nlcs, setNlc } = useNlcInfo();
    const { totalNlc, setTotalNlc } = useTotalNlc();
    const { uuidFree, setUuidFree } = useUuidFree();
    const [limitNlc, setLimitNlc] = useState(0);
    const [expiredAt, setExpiredAt] = useState(0);
    const { setqcAuto } = useQcAutoOnline();
    const { setAtkCityId } = useQcAtkCityIds();
    const { setDefCityId } = useQcDefCityIds()
    const { setAtkingCityId } = useQcAtkingCityIds();
    const { setAtkingPlayer } = useQcAtkingPlayers();
    const { setCityInfoBlood, setCityInfoPoint } = useQcCityInfos();
    const { updatePlayerEquipment, updateSingleEquipment } = usePlayerEquipment();
    const { setRmEquipment } = useRemoveEquipment();
    const { updatePlayerTrucLoc } = usePlayerTrucLoc();


    const updateFarmingSeaFood = (playerId, status = true) => {
        setFarmingSeaFood(prevFarmingData => {
            // Kiểm tra nếu playerId đã tồn tại trong state và có trạng thái khác với true
            if (!prevFarmingData[playerId] || prevFarmingData[playerId].status !== status) {
                // Tạo bản sao của state cũ và cập nhật trạng thái của player thành true
                const updatedFarmingData = {
                    ...prevFarmingData,
                    [playerId]: { ...prevFarmingData[playerId], status: status }
                };
                return updatedFarmingData; // Trả về state mới với sự thay đổi
            }

            // Nếu trạng thái không thay đổi hoặc playerId không tồn tại, trả về state cũ
            return prevFarmingData;
        });
    };



    const normalizePlayerWjh5 = (playerInfoFromWjh5) => {
        if (playerInfoFromWjh5 == null) return null;
        try {
            const playerInfo = {
                "Id": playerInfoFromWjh5.PlayerId,
                "Country": playerInfoFromWjh5.Country,
                "Name": playerInfoFromWjh5.Name,
                "Level": playerInfoFromWjh5.Level,
                "ServerId": playerInfoFromWjh5.ServerId,
                "ServerName": localServerInfo[playerInfoFromWjh5.ServerId].Name,
                "ShortName": localServerInfo[playerInfoFromWjh5.ServerId].ShortName,
                "Port": localServerInfo[playerInfoFromWjh5.ServerId].Port,
                "UserName": localUserInfo.Username,
                "Token": localUserInfo.Token,
                "UserId": localUserInfo.UserId,
                "NLC": 0,
                "Status": 0,
                "totalNlc": 0,
                "ql": 0,
                "gold": 0,
                "currentNlc": 0
            }
            return playerInfo
        } catch (error) {
            return null
        }
    }

    const mergPlayerInfo = (playerFromDB) => {
        const mergPlayerInfo = {};
        if (playerFromDB != null) {
            for (const playerId in playerFromDB) {
                mergPlayerInfo[playerId] = playerFromDB[playerId];
                mergPlayerInfo[playerId].ServerName = localServerInfo[mergPlayerInfo[playerId].ServerId].Name;
                mergPlayerInfo[playerId].ShortName = localServerInfo[mergPlayerInfo[playerId].ServerId].ShortName;
                mergPlayerInfo[playerId].Port = localServerInfo[mergPlayerInfo[playerId].ServerId].Port;
                // mergPlayerInfo[playerId].UserName = localUserInfo.Username;
                mergPlayerInfo[playerId].Token = localUserInfo.Token;
                mergPlayerInfo[playerId].UserId = localUserInfo.UserId;
            }
        }

        for (const playerId in localPlayerInfo) {
            if (!(playerId in mergPlayerInfo)) {
                mergPlayerInfo[playerId] = normalizePlayerWjh5(localPlayerInfo[playerId]);
                mergPlayerInfo[playerId].CanStart = false;
            } else {
                mergPlayerInfo[playerId].Country = localPlayerInfo[playerId].Country;
                mergPlayerInfo[playerId].CanStart = true;
            }
        }

        for (const playerId in mergPlayerInfo) {
            if (mergPlayerInfo[playerId].Config == null || mergPlayerInfo[playerId].Config == {}) {
                mergPlayerInfo[playerId].Config = getDefaultConfig();
            }
            if (mergPlayerInfo[playerId].resources == null || mergPlayerInfo[playerId].resources == {}) {
                mergPlayerInfo[playerId].resources = getDefaultResource();
            }
            if (mergPlayerInfo[playerId].resourcesQuantity == null || mergPlayerInfo[playerId].resourcesQuantity == {}) {
                mergPlayerInfo[playerId].resourcesQuantity = getDefaultResource();
            }
        }
        return mergPlayerInfo;

    }

    const getDefaultConfig = () => {
        const dConfig = {};
        for (const key in PLAYER_CONFIG) {
            if (PLAYER_CONFIG[key] == PLAYER_CONFIG.ID_PRIORITY_HAI_SAN
            ) {
                dConfig[PLAYER_CONFIG[key]] = [];
            } else dConfig[PLAYER_CONFIG[key]] = 0;
        }
        return dConfig;
    }
    const getDefaultResource = () => {
        const dResource = {};
        for (const key in RESOURCES_ID) {
            dResource[RESOURCES_ID[key]] = 0;
        }
        return dResource;
    }

    const setDataToStateEquipment = (playerId, equipments) => {
        updatePlayerEquipment(playerId, equipments);
    }

    const setSingleDataToStateEquipment = (playerId, idCfg, count) => {
        updateSingleEquipment(playerId, idCfg, count)
        setRmEquipment(playerId, { idCfg: idCfg, count: count })

    }

    const setDatatoStateTrucLoc = (playerId, trucLocStatus) => {
        updatePlayerTrucLoc(playerId, trucLocStatus);
    }

    const setDataToStateResource = (playerId, data) => {
        for (const id in data) {
            updateSingleResourceTotal(playerId, id, Number(data[id]));
        }
        setOnline(playerId, true);
    }
    const setDataToStateResourceQuantity = (playerId, data) => {
        for (const id in data) {
            updateSingleResourceQuantity(playerId, id, Number(data[id]));
        }
    }
    const setDataToStateConfig = (playerId, configs) => {
        updatePlayerConfig(playerId, configs);
    }
    const setDataToStateMap = (playerId, data) => {

        const _data = data;
        const protocol = data.protocol;
        if (protocol === SOCKET_EVENT.UUID_NOTIFY_CANCELED_TEAM_TROOP) _data.status = BATTLE_RESULT.CANCEL
        else if (protocol === SOCKET_EVENT.UUID_NOTIFY_CREATED_TEAM_TROOP) _data.status = BATTLE_RESULT.CREATED
        else if (protocol === SOCKET_EVENT.UUID_NOTIFY_JOINED_TEAM_TROOP) _data.status = BATTLE_RESULT.JOINED
        _data.timeStamp = new Date().toLocaleTimeString('en-GB', { hour12: false })
        setMap(playerId, _data);
    }
    const setDataToStateOnline = (playerId, data) => {
        //console.log('setDataToStateOnline', playerId, data);
        setOnline(playerId, true)
    }
    const setDataToStateFarmingSeaFood = (playerId, data) => {
        updateFarmingSeaFood(playerId, true);
        setTimeoutFarmingSeaFood(playerId);
    }

    const setDataToStateQuocChien = (playerId, data) => {
        if (data.AtkCityIds != null) {
            setAtkCityId(playerId, data.AtkCityIds);
        }
        if (data.DefCityIds != null) {
            setDefCityId(playerId, data.DefCityIds)
        }
        if (data.AtkPlayer != null) {
            setAtkingPlayer(playerId, data.AtkPlayer, data.BattleResult);
        }
        if (data.AtkCityId != null) {
            setAtkingCityId(playerId, data.AtkCityId);
        }
        if (data.CityInfo != null) {
            setCityInfoPoint(playerId, data.CityInfo.Point);
            setCityInfoBlood(playerId, data.CityInfo.Blood);
        }
        if (data.status !== null) {
            setqcAuto(playerId, data.status === 0);
        }
    }

    const setTimeoutFarmingSeaFood = (playerId) => {
        clearTimeout(idTimeoutFarmingSeaFood[playerId]);
        //console.log('clearTimeoutFarmingSeaFood');
        idTimeoutFarmingSeaFood[playerId] = setTimeout(() => {
            //console.log('clearTimeoutFarmingSeaFood', 'change status to false');
            updateFarmingSeaFood(playerId, false);
        }, TIMEOUT_FARMING_SEADFOOD);
    }

    const socketOnMessage = (data) => {
        if (data?.Id == null || data?.Data?.protocol == null) return;
        const playerId = data.Id;
        const protocol = data.Data.protocol;
        const revData = data.Data;
        if (!allPlayerId.some(playerId => playerId === playerId)) return;
        //console.log('socketOnMessage', revData)
        try {
            if (protocol == SOCKET_EVENT.UUID_NOTIFY_UPDATE_RESOURCE) {
                setDataToStateResource(playerId, revData.resources);
                setDataToStateResourceQuantity(playerId, revData.resourcesQuantity);
                setTotalNlc(revData.currentNlc)
                setNlc(playerId, revData.nlc);
                return;
            }
            if (protocol == SOCKET_EVENT.UUID_NOTIFY_JOINED_TEAM_TROOP ||
                protocol == SOCKET_EVENT.UUID_NOTIFY_CANCELED_TEAM_TROOP ||
                protocol == SOCKET_EVENT.UUID_NOTIFY_DONE_TEAM_TROOP ||
                protocol == SOCKET_EVENT.UUID_NOTIFY_CREATED_TEAM_TROOP
            ) {
                setDataToStateMap(playerId, revData);
                return;
            }
            if (protocol == SOCKET_EVENT.UUID_NOTIFY_ONLINE) {
                setDataToStateOnline(playerId, { status: true })
                return;
            }
            if (protocol == SOCKET_EVENT.UUID_NOTIFY_FARMING_SEA_FOOD) {
                setDataToStateFarmingSeaFood(playerId, { status: true });
                return;
            }
            if (protocol == SOCKET_EVENT.UUID_NOTIFY_AUTO_QUOC_CHIEN) {
                setDataToStateQuocChien(playerId, revData);
                return;
            }
            if (protocol == SOCKET_EVENT.UUID_NOTIFY_UPDATE_CONFIG) {
                setDataToStateConfig(playerId, revData.configs);
                return;
            }
            if (protocol == SOCKET_EVENT.UUID_NOTIFY_UPDATE_EQUIPMENTS) {
                setDataToStateEquipment(playerId, revData.equipments)
                return;
            }
            if (protocol == SOCKET_EVENT.UUID_NOTIFY_REMOVE_EQUIPMENTS) {
                const equipment = revData.equipments;
                if (equipment == null) return;
                Object.entries(equipment).forEach(([idCfg, count]) => {
                    setSingleDataToStateEquipment(playerId, idCfg, count);
                })
                return;
            }
            if (protocol == SOCKET_EVENT.UUID_NOTIFY_AUTO_TRUC_LOC) {
                const tournamentCombat = revData.tournamentCombat;
                if (tournamentCombat == null) return;
                setDatatoStateTrucLoc(playerId, tournamentCombat);
            }

        } catch (error) {

        }
    }


    const initSocket = () => {
        if (!socketRef.current) {
            const token = localTokenInfo.token;
            // console.log('Socket', HOST_AUTO_SERVER)
            socketRef.current = io(HOST_SOCKET_SERVER, {
                auth: {
                    token: token
                },
                path: PATH_SOCKET_SERVER,
            })

            socketRef.current.on("message", (data) => {
                //console.log('message', data);
                socketOnMessage(data);
            });
        }
    }

    const handleEventCharacter = (event, data) => {
        if (event === HANDLE_EVENT_CHARACTER.START_GAME) {
            const playerId = data?.player?.playerId
            if (playerId == null) return;

            return;
        }
        if (event == HANDLE_EVENT_CHARACTER.STOP_GAME) {
            const playerId = data?.player?.playerId
            setOnline(playerId, false)
            return;
        }
    }

    useEffect(() => {
        navigate(nextScreen(SCREEN_ROUTER.DASH_BOARD));
    }, [])

    useEffect(() => {
        //console.log("Chạy một lần khi component mount");
        const _players = []
        try {
            getPlayersbyToken().then((res) => {
                // console.log( 'Dashboard 0', res)
                if (res.error == false) {
                    const players = mergPlayerInfo(res?.data?.players)
                    allPlayerId.splice(0, allPlayerId.length);
                    setTotalNlc(res.data.token.sumNlc);
                    setUuidFree(res.data.token.uuid_free);
                    setExpiredAt(res.data.token.ExpiredAt * 1000);
                    setLimitNlc(res.data.token.LimitNlc);
                    const sortedPlayers = Object.entries(players)
                        .sort(([idA, playerA], [idB, playerB]) => {
                            // Sắp xếp theo UserName = localUserInfo.Username
                            const priorityA = playerA.UserName === localUserInfo.Username ? -1 : 1;
                            const priorityB = playerB.UserName === localUserInfo.Username ? -1 : 1;
                            // console.log('Dashboard sort', priorityA, priorityB)
                            if (priorityA !== priorityB) return priorityA - priorityB;
                            // Sắp xếp theo Status (true trước false)
                            if (playerB.Status !== playerA.Status) {
                                return playerB.Status - playerA.Status;
                            }
                            // Sắp xếp theo Level (giảm dần)
                            if (playerB.Level !== playerA.Level) {
                                return playerB.Level - playerA.Level;
                            }
                            // Sắp xếp theo playerId theo thứ tự alphabet
                            return idA.localeCompare(idB, undefined, { numeric: true, sensitivity: "base" });
                        });


                    for (const [playerId, _player] of sortedPlayers) {
                        let { Config, resources, resourcesQuantity, ...playerData } = _player;
                        _players.push(playerData);
                        updatePlayerConfig(playerId, Config);
                        updatePlayerResourceTotal(playerId, resources);
                        updatePlayerResourceQuantity(playerId, resourcesQuantity);
                        updateFarmingSeaFood(playerId, false);
                        setNlc(playerId, playerData.NLC);
                        updatePlayer(playerId, playerData);
                        if (_player.AtkCityIds != null) {
                            setAtkCityId(playerId, _player.AtkCityIds)
                        }
                        if (_player.DefCityIds != null) {
                            setDefCityId(playerId, _player.DefCityIds)
                        }
                        setOnline(playerId, players[playerId]?.Status == true)
                        // updatePlayersInfo(playerId, playerData);
                        allPlayerId.push(playerId);
                    }
                    setPlayersInfo(_players);
                    initSocket();
                }
                else if (res.status == 401) {
                    // console.log('Dashboard', res)
                    toast.error(CODE_EXPIRED);
                    removeLocalStorage(STORAGE_KEY.LOGIN_TOKEN)
                    navigate(SCREEN_ROUTER.LOGIN_TOKEN);
                }
            });
        } catch (error) {
            removeLocalStorage(STORAGE_KEY.COOKIE_INFO);
            removeLocalStorage(STORAGE_KEY.PLAYER_INFO);
            removeLocalStorage(STORAGE_KEY.USER_INFO);
            removeLocalStorage(STORAGE_KEY.SERVER_INFO);
            navigator(SCREEN_ROUTER.LOGIN_METHOD);
        }
        // Nếu cần cleanup khi component unmount, có thể return một hàm trong đây
        return () => {
            if (socketRef.current) {
                socketRef.current.close();
                socketRef.current = null;
                //console.log('Close socket')
            }
        };
    }, [isUpdateCookie]); // Truyền mảng rỗng để chỉ chạy một lần

    return (
        <Container fluid>
            <Row className="h5 text-primary align-items-center text-nowrap d-flex justify-content-between mt-2">
                <Col className="align-content-start align-items-start d-flex">
                <span>{stringToShort(localUserInfo.Username, 9)}</span>
                </Col>
                {uuidFree ? <Col ><span>Tổng NLC: <Badge bg='primary'>FREE</Badge> {totalNlc}</span></Col> :
                    <Col ><span>{`Tổng NLC: ${totalNlc}/${limitNlc}`}</span></Col>}
                <Col className="d-none d-md-inline"><span>{
                    `Hết Hạn: ${new Date(expiredAt)
                        .toLocaleDateString('vi-VN', {
                            day: '2-digit',
                            month: '2-digit',
                        })}`}</span></Col>
            </Row>
            {playersInfo.map(player => (
                <Character
                    key={player.Id}
                    playerId={player.Id}
                    isFarmingSeaFood={farmingSeaFood[player.Id]?.status == true}
                    onClick={handleEventCharacter} />
            ))}
        </Container>
    );



}

export default DashBoard;